export function capitalize(str: string): string {
  if (!str.length) {
    return "";
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export const ethAddressRegEx = /^0x[a-fA-F0-9]{40}$/;
